import React from 'react';
import { usePermissions } from '../contexts/PermissionsContext';
import AccessDenied from './AccessDenied';

const ProtectedRoute = ({ children, module, customMessage = null, customTitle = null }) => {
  const { canAccess, loading } = usePermissions();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-emerald-600 mx-auto mb-4"></div>
          <p className="text-slate-600">Berechtigung wird überprüft...</p>
        </div>
      </div>
    );
  }

  // Temporary: Allow billing for all authenticated users
  const hasAccess = module === 'billing' ? true : canAccess(module);
  
  if (!hasAccess) {
    return (
      <AccessDenied 
        title={customTitle}
        message={customMessage}
      />
    );
  }

  return children;
};

export default ProtectedRoute;